export default __webpack_public_path__ + "static/media/mail.6f33cf86.svg";